import {
  FETCH_REQUESTS,
  FETCH_REQUESTS_SUCCESS,
  FETCH_REQUESTS_FAILURE,
} from "../../actions/actionTypes";

const initialState = {
  requests: [],
  loading: false,
  error: null,
  currentPage: 0,
  pageSize: 20,
  totalElements: 0,
  totalPages: 0,
};

export const requestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REQUESTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        requests: action.payload.content,
        currentPage: action.payload.currentPage,
        pageSize: action.payload.pageSize,
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages,
      };
    case FETCH_REQUESTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
